import React from "react";
import { Toggle_Profile } from "subframe/components/Toggle_Profile";
import { TabType } from "../../../types";

interface ProfileTabsProps {
  activeTab: TabType;
  onTabChange: (value: TabType) => void;
}

export const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabChange }) => {
  const handleTabChange = (value: string) => {
    onTabChange(value as TabType);
  };

  return (
    <Toggle_Profile
      className="h-auto w-full flex-none"
      value={activeTab}
      onValueChange={handleTabChange}
    >
      <Toggle_Profile.Item
        className="h-9 grow shrink-0 basis-0"
        icon={null}
        value={TabType.OVERVIEW}
      >
        Overview
      </Toggle_Profile.Item>
      <Toggle_Profile.Item
        className="h-9 grow shrink-0 basis-0"
        icon={null}
        value={TabType.SURVEY_HISTORY}
      >
        Survey History
      </Toggle_Profile.Item>
      <Toggle_Profile.Item
        className="h-9 grow shrink-0 basis-0"
        icon={null}
        value={TabType.ESCALATION_LOGS}
      >
        Escalation Logs
      </Toggle_Profile.Item>
      <Toggle_Profile.Item
        className="h-9 grow shrink-0 basis-0"
        icon={null}
        value={TabType.PROFILE_DETAILS}
      >
        Profile details
      </Toggle_Profile.Item>
    </Toggle_Profile>
  );
}; 